module.exports = __webpack_public_path__ + "img/source_point.5ad3a2c8.svg";